export const pushState = (path: string): void => {
	window.history.pushState(null, "", path);
};

export const CurrentUrl = window.location.protocol + "//" + window.location.host;

export const DEFAULT_FAVICON_URL = "/favicon.svg";